import axios from 'axios'
import router from '@/router'
import { useAuthStore } from '@/store/auth'
import { ElMessage } from 'element-plus'
import i18n from '@/lang/index.js'

const baseAxios = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api`,
  headers: {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
})

baseAxios.defaults.params = {}

baseAxios.interceptors.request.use(async (config) => {
  config.headers['Accept-Language'] = i18n.global.locale

  const storeAuth = useAuthStore()

  if (!storeAuth.isAuthenticated) {
    return config
  }

  if (storeAuth.isExpired) {
    try {
      storeAuth.refresh()
    } catch (err) {
      ElMessage.error(
        err.response.data.error
          ? err.response.data.reason
          : err.response.statusText
      )
    }
  }

  config.headers.Authorization = `Bearer ${storeAuth.token}`

  return config
})

baseAxios.interceptors.response.use(null, (error) => {
  if (error.response?.status === 401) {
    router.push('/sign-in')
  }

  if (error?.response?.data === 'inactive_user') {
    router.push('/sign-in')
  }

  return Promise.reject(error)
})

export default baseAxios
